var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCiCheckboxCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 11.1993V4.79935C2.66602 4.05268 2.66602 3.67935 2.81135 3.39402C2.93935 3.14268 3.14268 2.93935 3.39402 2.81135C3.67935 2.66602 4.05268 2.66602 4.79935 2.66602H11.1993C11.946 2.66602 12.3193 2.66602 12.604 2.81135C12.8553 2.93935 13.0593 3.14268 13.1873 3.39402C13.3327 3.67868 13.3327 4.05202 13.3327 4.79735V11.202C13.3327 11.9474 13.3327 12.32 13.1873 12.6047C13.0593 12.8557 12.8551 13.0596 12.604 13.1873C12.3193 13.3327 11.9467 13.3327 11.2013 13.3327H4.79735C4.05202 13.3327 3.67868 13.3327 3.39402 13.1873C3.14314 13.0595 2.93918 12.8556 2.81135 12.6047C2.66602 12.3193 2.66602 11.946 2.66602 11.1993Z",
    fill: "#7953D2",
    stroke: "#7953D2",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8L7.25 10L11 6",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiCheckboxCheck);
export default __webpack_public_path__ + "static/media/ci_checkbox-check.411b541b2b3e48375b42769761668fe0.svg";
export { ForwardRef as ReactComponent };